export default __webpack_public_path__ + "components/01-components/tile/icon-link.html.twig";